'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCameraAlt = function ImageCameraAlt(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
    _react2.default.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
  );
};
ImageCameraAlt = (0, _pure2.default)(ImageCameraAlt);
ImageCameraAlt.displayName = 'ImageCameraAlt';
ImageCameraAlt.muiName = 'SvgIcon';

exports.default = ImageCameraAlt;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/camera-alt.js
 ** module id = 2038
 ** module chunks = 0
 **/